// Font Loader Utility
// This utility helps load fonts dynamically from configuration

import { siteConfig } from '../config/siteConfig';

export const loadGoogleFonts = () => {
  const { googleFonts } = siteConfig.typography;
  
  Object.entries(googleFonts).forEach(([fontName, fontUrl]) => {
    // Check if font link already exists
    const existingLink = document.querySelector(`link[data-font="${fontName}"]`);
    
    if (!existingLink) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontUrl;
      link.setAttribute('data-font', fontName);
      document.head.appendChild(link);
    }
  });
};

export const updateCSSFontVariables = () => {
  const root = document.documentElement;
  const { fontFamily } = siteConfig.typography;
  
  // Update CSS custom properties with font families from config
  root.style.setProperty('--font-family-primary', fontFamily.primary);
  root.style.setProperty('--font-family-scrolling', fontFamily.scrolling);
  root.style.setProperty('--font-family-footer', fontFamily.footer);
  root.style.setProperty('--font-family-fallback', fontFamily.fallback);
};

// Initialize fonts when the utility is imported
export const initializeFonts = () => {
  loadGoogleFonts();
  updateCSSFontVariables();
};

const fontLoader = {
  loadGoogleFonts,
  updateCSSFontVariables,
  initializeFonts
}; 

export default fontLoader; 